module.exports = __webpack_public_path__ + "static/media/16-9.48cb4d47.mp3";